(() => {
  const dialog = document.getElementById('hh-pack-picker');
  if (!dialog) return;
  const form = dialog.querySelector('form');
  const options = dialog.querySelector('.hh-pack-options');
  const add = dialog.querySelector('.hh-pack-add');
  const error = dialog.querySelector('.hh-pack-error');
  const price = dialog.querySelector('.hh-pack-total');
  const image = dialog.querySelector('.hh-pack-image img');
  const vendor = dialog.querySelector('.hh-pack-vendor');
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: window.Shopify?.currency?.active || 'AUD', currencyDisplay: 'narrowSymbol' }).format(value / 100);
  let submitting = false;
  let product;
  let opener;
  let request;
  const showError = message => {
    error.textContent = message;
    error.hidden = false;
  };
  dialog.querySelector('.hh-pack-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    request?.abort();
    opener?.focus();
  });
  document.addEventListener('click', async event => {
    const link = event.target.closest('a.hh-choose-size,a.hh-favourite-product__choose');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    if (submitting) return;
    opener = link;
    product = null;
    add.disabled = true;
    error.hidden = true;
    price.textContent = '';
    const card = link.closest('article') || link.closest('[data-handle]');
    const shortTitle = card?.querySelector('[class$="__title"]')?.textContent.trim();
    const cardImage = card?.querySelector('img');
    dialog.querySelector('.hh-pack-title').textContent = shortTitle || '';
    vendor.textContent = '';
    image.hidden = !cardImage;
    if (cardImage) { image.src = cardImage.currentSrc || cardImage.src; image.alt = shortTitle || ''; }
    options.replaceChildren();
    options.setAttribute('aria-busy', 'true');
    dialog.showModal();
    request?.abort();
    request = new AbortController();
    try {
      const url = new URL(link.href);
      url.pathname = url.pathname.replace(/\/$/, '') + '.js';
      url.search = '';
      const response = await fetch(url, { signal: request.signal });
      if (!response.ok) throw new Error(dialog.dataset.errorLabel);
      product = await response.json();
      dialog.querySelector('.hh-pack-title').textContent = shortTitle || product.title.replace(new RegExp('^' + product.vendor.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*', 'i'), '');
      vendor.textContent = product.vendor;
      if (product.featured_image) { image.src = product.featured_image; image.alt = shortTitle || product.title; image.hidden = false; }
      product.variants.forEach(variant => {
        const label = document.createElement('label');
        label.className = 'hh-pack-option';
        const input = document.createElement('input');
        input.type = 'radio'; input.name = 'id'; input.value = variant.id; input.required = true; input.disabled = !variant.available;
        const size = document.createElement('span'); size.className = 'hh-pack-size'; size.textContent = variant.title;
        const amount = document.createElement('span'); amount.className = 'hh-pack-price'; amount.textContent = variant.available ? money(variant.price) : dialog.dataset.soldLabel;
        label.append(input, size, amount);
        options.append(label);
      });
      options.removeAttribute('aria-busy');
    } catch (e) {
      if (e.name !== 'AbortError') showError(dialog.dataset.errorLabel);
    }
  });
  options.addEventListener('change', event => {
    const variant = product?.variants.find(item => String(item.id) === event.target.value);
    add.disabled = !variant?.available;
    price.textContent = variant ? money(variant.price) : '';
    error.hidden = true;
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (add.disabled || !form.reportValidity()) return;
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const body = new FormData(form);
    if (cart) {
      body.append('sections', cart.getSectionsToRender().map(section => section.id).join(','));
      body.append('sections_url', location.pathname);
      cart.setActiveElement(opener);
    }
    add.disabled = true;
    submitting = true;
    options.querySelectorAll('input').forEach(input => { input.disabled = true; });
    add.setAttribute('aria-busy', 'true');
    error.hidden = true;
    try {
      const response = await fetch(window.routes?.cart_add_url || form.action, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || dialog.dataset.errorLabel);
      dialog.close();
      if (cart) {
        cart.classList.remove('is-empty');
        cart.renderContents(data);
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hh-pack-picker', productVariantId: body.get('id'), cartData: data });
      } else location.assign(window.routes?.cart_url || '/cart');
    } catch (e) {
      showError(e.message || dialog.dataset.errorLabel);
    } finally {
      submitting = false;
      options.querySelectorAll('input').forEach(input => { input.disabled = !product?.variants.find(item => String(item.id) === input.value)?.available; });
      add.disabled = !options.querySelector('input:checked:not(:disabled)');
      add.removeAttribute('aria-busy');
    }
  });
})();
